import React from 'react';
import BaseField, {
	BaseFieldProps,
} from '../../../../../Base/Components/Inputs/BaseField/BaseField';
import InsuranceCompanyBatchTypesMultiSelectWithCheckList from './InsuranceCompanyBatchTypesMultiSelectWithCheckList';

const InsuranceCompanyBatchTypesMultiSelectWithCheckListField: React.FC<
	BaseFieldProps
> = props => (
	<BaseField {...props}>
		<InsuranceCompanyBatchTypesMultiSelectWithCheckList portal={props.portal} />
	</BaseField>
);

export default InsuranceCompanyBatchTypesMultiSelectWithCheckListField;
